import React from 'react';
import './FieldPreview.css';
import FieldPreview from './FieldPreview';
import {buildFieldPreviewModel} from '../../utils/fieldPreview/buildFieldPreviewModel';
import {FIELD_PREVIEW_LEGEND, FIELD_PREVIEW_UNIT_LEGEND_ID} from '../../configs/fieldPreview';

// Образец — настоящая схема из одной ячейки: легенда не может разойтись с полем
const SAMPLE_GRID_CONFIG = {radius: 0, hexSize: 60, orientation: 'flat'};
const SAMPLE_CELL = '0,0';

const buildSampleModel = ({id, token}) => buildFieldPreviewModel({
  gridConfig: SAMPLE_GRID_CONFIG,
  hexes: token ? {[SAMPLE_CELL]: token} : {},
  units: id === FIELD_PREVIEW_UNIT_LEGEND_ID ? [{id, hexKey: SAMPLE_CELL}] : [],
});

const LEGEND_ENTRIES = FIELD_PREVIEW_LEGEND.map((entry) => ({...entry, model: buildSampleModel(entry)}));

/**
 * Условные обозначения схемы поля.
 *
 * @param {string[]} legendIds — какие обозначения показать, порядок — общий
 * @param {string} [className]
 */
const FieldPreviewLegend = React.memo(({legendIds, className = ''}) => (
  <ul className={`field-preview-legend ${className}`}>
    {LEGEND_ENTRIES.filter(({id}) => legendIds.includes(id)).map(({id, label, model}) => (
      <li key={id} className="field-preview-legend_item" data-legend={id}>
        <FieldPreview model={model} className="field-preview-legend_sample"/>
        {label}
      </li>
    ))}
  </ul>
));

export default FieldPreviewLegend;
